import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";

import "../css/Header.css";
import "../css/Menu.css";

import Container from "./Container";
import BurguerIcon from "../icons/BurguerIcon";
import BackArrowIcon from "../icons/BackArrowIcon";

import Search from "./Search";

import RepairLogo from "../images/Reparability.png";

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showNav: false,
			showLinen: false,
			showComfort: false,
			showServices: false,
			showDesign: false
		};

		this.toggleNav = this.toggleNav.bind(this);
		this.toggleLinenCare = this.toggleLinenCare.bind(this);
		this.toggleHomeComfort = this.toggleHomeComfort.bind(this);
		this.toggleServices = this.toggleServices.bind(this);
		this.toggleDesign = this.toggleDesign.bind(this);
	}

	componentWillMount() {
		this.unlisten = this.props.history.listen((location, action) => {
			document.body.className = "";
			this.setState({
				showNav: false,
				showLinen: false,
				showComfort: false,
				showServices: false,
				showDesign: false
			});
		});
	}

	componentWillUnmount() {
		this.unlisten();
	}

	toggleNav(e) {
		e.preventDefault();
		this.setState(prevState => ({
			showNav: !prevState.showNav
		}));

		document.body.className = "";

		if (!this.state.showNav) {
			document.body.className = "no-scroll";
		} else {
			this.setState(prevState => ({
				showLinen: false,
				showComfort: false,
				showServices: false,
				showDesign: false
			}));
		}
	}

	toggleLinenCare(e) {
		e.preventDefault();
		this.setState(prevState => ({
			showLinen: !prevState.showLinen,
			showComfort: false,
			showServices: false,
			showDesign: false
		}));
	}

	toggleHomeComfort(e) {
		e.preventDefault();
		this.setState(prevState => ({
			showLinen: false,
			showComfort: !prevState.showComfort,
			showServices: false,
			showDesign: false
		}));
	}

	toggleServices(e) {
		e.preventDefault();
		this.setState(prevState => ({
			showLinen: false,
			showComfort: false,
			showServices: !prevState.showServices,
			showDesign: false
		}));
	}

	toggleDesign(e) {
		e.preventDefault();
		this.setState(prevState => ({
			showLinen: false,
			showComfort: false,
			showServices: false,
			showDesign: !prevState.showDesign
		}));
	}

	back() {
		this.setState({
			showServices: false,
			showComfort: false,
			showLinen: false,
			showDesign: false
		});
	}

	render() {
		return (
			<section>
				<Container>
					<div className="Headerpage">
						<div className="HeaderLeft">
							<a
								href=""
								className={"ToggleNav " + (this.state.showNav ? "active" : "")}
								onClick={this.toggleNav}>
								<BurguerIcon width={32} height={32} color="#fff" />
								<span className="label-menu">Menu</span>
							</a>
						</div>
						<div className="HeaderCenter">
							<h1>
								<Link to="/">
									<img
										className="Logo"
										title="Rowenta International"
										alt="Rowenta International"
										src="https://www.rowentausa.com/medias/rowenta-logo.png?context=bWFzdGVyfGltYWdlc3wxNjUyfGltYWdlL3BuZ3xpbWFnZXMvaGRjL2gwNy84OTE1Njg4MzI1MTUwLnBuZ3w5NGYyMjRlOGNiZDI2ZTI5ODEzZDgzYzgwYjFmOWJhZTRkYWUzZGRjNmI1Mjg1Njc3YzFkZTY4OWRiNmYxMmNi"
									/>
								</Link>
							</h1>
						</div>
						<div className="HeaderRight">
							<Link to="/repairability">
								<img
									src={RepairLogo}
									alt="Repairable Products"
									className="repair-logo"
								/>
							</Link>
							<Search />
						</div>
					</div>
				</Container>
				<nav className={"main-nav " + (this.state.showNav ? "show-nav" : "")}>
					<div className="niv1">
						<h2>
							<i>Discover</i> <strong>our products</strong>
						</h2>
						<ul className="navigation">
							<li>
								<img src="https://www.rowentausa.com/medias/icon-soin-linge.png?context=bWFzdGVyfGltYWdlc3wxNjAyfGltYWdlL3BuZ3xpbWFnZXMvaDJmL2hmNy84OTMxNjIyMzU0OTc0LnBuZ3wwMjc1NDdiOTkxNDdmMzNjNDIxMzk3NDZlODE1MjNjMGVkN2FhMGNhNmNiN2I1MmJjM2FlMjI3N2I4ZDNjNDE0" />
								<a href="#" onClick={this.toggleLinenCare}>
									Linen Care
								</a>
								<div className={"niv2" + (this.state.showLinen ? " open" : "")}>
									{this.state.showLinen ? (
										<button className="back-button" onClick={() => this.back()}>
											<BackArrowIcon color="#fff" width={25} height={25} />
										</button>
									) : null}

									<div className="col">
										<Link to="/linen-care/">
											<h2>Linen Care</h2>
										</Link>
										<ul>
											<li>
												<Link to="/linen-care/steam-irons">Steam Irons</Link>
											</li>
											<li>
												<Link to="/linen-care/steam-gens">
													Steam Generators
												</Link>
											</li>
											<li>
												<Link to="/linen-care/garment-steamers">
													Garment Steamers
												</Link>
											</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<img src="https://www.rowentausa.com/medias/icon-confort.png?context=bWFzdGVyfGltYWdlc3wxNTMzfGltYWdlL3BuZ3xpbWFnZXMvaDQ4L2gwNy84OTMxNjIyMTU4MzY2LnBuZ3xiMjQyNWE1ZDg4ZWNkNGViZGFkMDM1ZjVjODIzZDgwZDgwY2Q5YWI0NDQzNDI4Y2Q5ZmQ1NzllOTFmMDg2ODgx" />
								<a href="#" onClick={this.toggleHomeComfort}>
									Home Comfort
								</a>
								<div
									className={"niv2" + (this.state.showComfort ? " open" : "")}>
									{this.state.showComfort ? (
										<button className="back-button" onClick={() => this.back()}>
											<BackArrowIcon color="#fff" width={25} height={25} />
										</button>
									) : null}

									<div className="col">
										<Link to="/home-comfort/">
											<h2>Home Comfort</h2>
										</Link>
										<ul>
											<li>
												<Link to="/home-comfort/air-purifiers">
													Air Purifiers
												</Link>
											</li>
											<li>
												<Link to="/home-comfort/humidifiers">Humidifiers</Link>
											</li>
											<li>
												<Link to="/home-comfort/fans">Fans</Link>
											</li>
											<li>
												<Link to="/home-comfort/heaters">Heaters</Link>
											</li>
										</ul>
									</div>
								</div>
							</li>
							<li className="secondary-nav direct-link">
								<img src="https://www.rowentausa.com/medias/Picto-program-registration2.png?context=bWFzdGVyfHJvb3R8NTEwfGltYWdlL3BuZ3xoMDYvaGZhLzkyNDE1NTUzMzcyNDYucG5nfGIwNmEzYjk0MTkxZjhhYWRlYWM2ZjM1MzQ1ZmQ3OTNmNWMzNzM1ZTc5ZjhiOWJjMmI1MzQyYTkzYzUwNWM3ZjI" />
								<Link to="/registermyproduct" title="Register My Product">
									PRODUCT REGISTRATION
								</Link>
							</li>
							<li className="secondary-nav direct-link">
								<img
									style={{
										width: "32px",
										left: "7px",
										marginRight: "19px",
										top: "5px"
									}}
									src="data:image/png;base64,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"
								/>
								<Link to="/repairability" title="Register My Product">
									10YR Repairability
								</Link>
							</li>
							<li className="secondary-nav">
								<a href="#" onClick={this.toggleServices}>
									CONSUMER SERVICES
								</a>
								<div
									className={"niv2" + (this.state.showServices ? " open" : "")}>
									{this.state.showServices ? (
										<button className="back-button" onClick={() => this.back()}>
											<BackArrowIcon color="#fff" width={25} height={25} />
										</button>
									) : null}

									<div className="col">
										<ul>
											<li>
												<Link to="/accessories">SPARES AND ACCESSORIES</Link>
											</li>
											<li>
												<Link
													to="/consumer-services/contact-us"
													title="Contact Us">
													CONTACT US
												</Link>
											</li>
											<li>
												<Link to="/guarantee">GUARANTEE</Link>
											</li>
											<li>
												<Link to="/instructions-for-use">
													INSTRUCTIONS FOR USE
												</Link>
											</li>
											<li>
												<Link to="/repairs">REPAIRS</Link>
											</li>
											<li>
												<Link
													to="/registermyproduct"
													title="Register My Product">
													PRODUCT REGISTRATION
												</Link>
											</li>
											<li>
												<Link to="/repairability" title="10YR Repairability">
													10YR Repairability
												</Link>
											</li>
											<li>
												<Link to="/where-to-buy" title="Where to Buy">
													WHERE TO BUY
												</Link>
											</li>
										</ul>
									</div>
								</div>
							</li>
							<li className="secondary-nav direct-link">
								<Link to="/about" title="About us">
									ABOUT US
								</Link>
							</li>

							{/*<li className="secondary-nav">
								<a href="#" onClick={this.toggleDesign}>ROWENTA BY DESIGN</a>
								<div className={"niv2" + (this.state.showDesign ? ' open' : '')} >

									{this.state.showDesign ? (
										<button className="back-button" onClick={() => this.back()}>
											<BackArrowIcon color="#fff" width={25} height={25} />
										</button>
									) : null}

									<div className="col">
										<ul>
											<li>
												<Link to="/steam-irons">ABOUT US</Link>
											</li>
										</ul>
									</div>
								</div>
							</li>*/}
						</ul>
					</div>
				</nav>
				<div
					className={"overlay" + (this.state.showNav ? " open" : "")}
					onClick={this.toggleNav}
				/>
			</section>
		);
	}
}

export default withRouter(Header);
